



































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { commonFacade } from "@/store/modules/common/common.facade";

export default defineComponent({
  name: "LanguageSelector",
  props: {
    id: {
      type: String,
      default: "header",
    },
  },
  setup(props, { emit }) {
    const currentLanguage = computed(commonFacade.currentLanguage);
    const language = ref<string>(currentLanguage.value as string);
    const tenant = computed(commonFacade.tenant);
    const tenantLoading = computed(commonFacade.tenantLoading);

    watch(currentLanguage, (curr) => {
      language.value = curr as string;
    });

    const getCode = (code: string) => {
      return code === "en" ? "gb" : code.toLocaleLowerCase();
    };

    const selectionChanged = (languageCode: string) => {
      emit("languageSelected", languageCode);
      // emit("languageSelected", languageCode.toLocaleLowerCase());
    };

    return {
      language,
      tenant,
      tenantLoading,
      getCode,
      selectionChanged,
    };
  },
});
